import { toLanguageCodes } from '@sortlist-frontend/translation';

import { language } from '_core/utils/languages/languages.types';
import { getLanguageTranslator, isSupportedLanguageLocale } from '_core/utils/languages/languages.util';

export const LANGUAGES_MIN_LENGTH = 5;

export const getLanguagesFromCodes = (codes: string[], locale: string, isToggledLanguages: boolean): string => {
  const translator = isSupportedLanguageLocale(locale) ? getLanguageTranslator(locale) : null;
  const names = toLanguageCodes(codes).map((code) => translator?.(code as language) ?? code);

  return names.length <= LANGUAGES_MIN_LENGTH || isToggledLanguages
    ? names.join(', ')
    : names.slice(0, LANGUAGES_MIN_LENGTH).join(', ') + '...';
};
